import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  showToast: false,
  options: {
    title: 'Alert',
    message: 'This is an alert toast',
    color: 'primary',
    action: 'false',
    actionLabel: '',
    actionHandler: null,
  },
}

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (state, action) => {
      state.showToast = true
      state.options = action.payload
    },
    hideToast: (state) => {
      state.showToast = false
    },
  },
})

export default toastSlice.reducer
export const { showToast, hideToast } = toastSlice.actions
